import type { CreateProduct, UpdateProduct } from '@/types'
import { createFormData } from '@/utils'
import type { Product } from '@prisma/client'

import axios from '../axios'
import { tryCatch } from '../catch'

export class ProductService {
  static async findAll(query: BaseQuery) {
    try {
      const response = await axios.get<IPaginate<Product>>(`/products`, { params: query })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ProductService.findAll`', error)
    }
  }

  static async findOne(id: number) {
    try {
      const response = await axios.get<Product>(`/products/${id}`)
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ProductService.findOne`', error)
    }
  }

  static async create(data: CreateProduct) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.post<IResponse>(`/products`, formData, { headers })
      if (response.data) {
        return response.data
      }
    } catch (error) {
      tryCatch('`ProductService.create`', error)
    }
  }

  static async update(id: number, data: UpdateProduct) {
    try {
      const [formData, headers] = createFormData(data)
      const response = await axios.patch<IResponse>(`/products/${id}`, formData, { headers })
      return response.data
    } catch (error) {
      tryCatch('`ProductService.update`', error)
    }
  }

  static async delete(id: number) {
    try {
      const response = await axios.delete<IResponse>(`/products/${id}`)
      return response.data
    } catch (error) {
      tryCatch('`ProductService.delete`', error)
    }
  }
}
